export default "__VITE_ASSET__Gb9$Ahau__"